import React, { useEffect, useState, useCallback } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { validateToken, setupInactivityHandler } from './tokenVerification'; // Correct path

const PrivateRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    // Clear user data
    localStorage.removeItem('user');
    // Redirect to login
    navigate('/', { replace: true });
  }, [navigate]);

  const showSessionExpiredPopup = useCallback(() => {
    alert('Your session has expired. You will be logged out.');
  }, []);

  useEffect(() => {
    const checkAuth = async () => {
      // console.log('[PrivateRoute] Validating token...');
      try {
        await validateToken(handleLogout, showSessionExpiredPopup);
        // console.log('[PrivateRoute] User is authenticated.');
        setIsAuthenticated(true);
      } catch (error) {
        // console.error('[PrivateRoute] Authentication failed:', error);
        setIsAuthenticated(false);
      }
    };

    checkAuth();

    // Set up inactivity handler
    const removeInactivityHandler = setupInactivityHandler(handleLogout, showSessionExpiredPopup);

    // Cleanup on unmount
    return () => {
      removeInactivityHandler();
    };
  }, [handleLogout, showSessionExpiredPopup]);

  if (isAuthenticated === null) return <div>Loading...</div>;

  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;